/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { GetSettingsServicesApiResponse } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSettingsServices: build.query<GetSettingsServicesApiResponse, void>({
      query: () => ({ method: 'GET', url: `/v1/settings/services` }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getSettingsServicesApi };
export const { useGetSettingsServicesQuery, useLazyGetSettingsServicesQuery } = injectedRtkApi;
